export default {
  units: (state) => state.units,
  unitsGroups: (state) => state.unitsGroups,
  selectedUnits: (state) => state.selectedUnits,
  unavailableUnitsIds: (state) => state.unavailableUnitsIds,
  unitSelected: (state) => state.unitSelected,
  tagList: (state) => state.tagList,
  deletedTag: (state) => state.deletedTag,
  updatedTag: (state) => state.updatedTag,
}
